import { ERROR_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Error/config";
import { ERRORS_TRANSLATION_NAMESPACE } from "../../config";
import errorComponentsTranslations from "./components-error.fr-FR.json";
import errorsTranslations from "./errors.fr-FR.json";

export const frFRTranslations = {
    [ERRORS_TRANSLATION_NAMESPACE]: errorsTranslations,
    [ERROR_COMPONENTS_TRANSLATION_NAMESPACE]: errorComponentsTranslations,
};
